import React from "react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { Trash2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useTranslation } from "react-i18next"

interface ClearRouteDialogProps {
  onConfirm: () => void
  disabled?: boolean
}

export const ClearRouteDialog: React.FC<ClearRouteDialogProps> = ({
  onConfirm,
  disabled = false,
}) => {
  const { t } = useTranslation()
  const inProduct = Boolean(window.XMPP && !window.anonymousXMPP)

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          disabled={disabled}
          variant="outline"
          size="sm"
          className="h-8 text-xs"
          aria-label={t("maps.clearRouteDialog.ariaLabel")}
        >
          <Trash2 className="h-4 w-4 text-muted-foreground" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("maps.clearRouteDialog.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {inProduct
              ? t("maps.clearRouteDialog.descriptionWithSession")
              : t("maps.clearRouteDialog.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700"
          >
            {t("maps.clearRouteDialog.title")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
